<template>
    <div class="hero-body formular-230">
        <div class="container">
            <h3 class="top-text columns has-text-white">
                <div class="column is-3 is-offset-1 title has-text-white form-title" v-if="screenWidth >= 1024">
                    minticreative.org
                </div>
                <div class="column is-7">
                    <div class="is-flex is-flex-direction-row has-text-white">
                        <div
                            class="is-uppercase title has-text-white formular-title-text"
                            :class="{ 'on-mobile': screenWidth <= 1023 }"
                        >
                            formular 230
                        </div>
                        <div class="sub-text" v-if="screenWidth > 1023">
                            Cerere distribuire sume<br />
                            reprezentand 3,5% din impozitul pe venit
                        </div>
                    </div>
                </div>
            </h3>
            <div class="columns main-columns">
                <div
                    class="column column-left is-3 is-offset-1 has-shadow"
                    :class="{ 'on-mobile-left': screenWidth <= 1023 }"
                    :style="{
                        backgroundImage: screenWidth > 1024 ? 'url(' + kidsImage + ')' : '',
                    }"
                >
                    <div class="info">
                        <img :src="logo" class="logo" alt="" />
                        <div class="subtitle has-text-weight-semibold is-size-5 has-text-weight-bold">Informatii</div>
                        <div class="info-text">
                            Completeaza formularul de mai jos printr-un mecanism simplu care asigura un sprijin
                            important copiilor din Asociatia Minti Creative, prin redirectionarea a 3,5% din impozitul
                            tau pe venit. Dupa ce ai completat datele si ai semnat, apasa butonul “Depune formularul”.
                            Acesta va ajunge in baza noastra de date si se va depune la ANAF fara a mai fi necesara
                            imprimarea sau trimiterea formularului prin posta.
                        </div>
                    </div>
                </div>
                <div class="column column-right is-6 has-shadow" :class="{ 'on-mobile-right': screenWidth <= 1023 }">
                    <div class="overlay-invalid" v-if="registrationDisabled">
                        <div class="ov-background"></div>
                        <div class="ov-text">
                            <p>
                                Iti multumim in numele intregii echipe Minti Creative pentru intentia de a redirectiona
                                3.5% din impozitul pe venit.
                            </p>
                            <p>
                                Campania de colectare a formularelor 230 s-a incheiat. Te invitam insa sa te alaturi
                                celorlalte proiecte derulate in cadrul Asociatiei Minti Creative.
                            </p>
                            <p style="margin-top: 15px">Multumim!</p>
                        </div>
                    </div>
                    <div class="overlay-invalid" v-else-if="invalidUID">
                        <div class="ov-background"></div>
                        <div class="ov-text">Link invalid</div>
                    </div>
                    <b-loading :is-full-page="false" v-model="isSubmitPending" :can-cancel="false"></b-loading>

                    <ValidationObserver ref="observer" v-slot="{}">
                        <div class="box has-text-left">
                            <div
                                class="title has-text-weight-semibold is-size-4 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                            >
                                <div>
                                    <b-icon class="mr-3 has-text-grey-lighter" icon="home-heart" size="is-large">
                                    </b-icon>
                                </div>
                                <div>Beneficiar</div>
                            </div>
                            <div class="columns" :class="{ 'on-mobile': screenWidth <= 1023 }">
                                <div class="column">
                                    <b-input size="is-medium" disabled :value="beneficiar" minlength="1"></b-input>
                                </div>
                                <div class="column">
                                    <b-input size="is-medium" disabled :value="ibanBeneficiar" minlength="1"></b-input>
                                </div>
                            </div>
                            <div
                                class="title has-text-weight-semibold is-size-4 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                            >
                                <div>
                                    <b-icon
                                        class="mr-3 has-text-grey-lighter"
                                        icon="account-details-outline"
                                        size="is-large"
                                    >
                                    </b-icon>
                                </div>
                                <div>Date contribuabil</div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider
                                        rules="required|alpha_spaces_minus|min:2|max:45"
                                        name="nume"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Nume"
                                                v-model.trim="form.nume"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider
                                        rules="required|alpha_spaces_minus|min:2|max:45"
                                        name="prenume"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Prenume"
                                                v-model.trim="form.prenume"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider
                                        rules="max:1|alpha"
                                        name="initiala"
                                        v-slot="{ errors, valid, changed }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid && changed }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Initiala tata"
                                                v-model.trim="form.initiala"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider
                                        rules="required|cnplength:13|cnpinteger|cnpformat|cnpvalability"
                                        name="CNP"
                                        vid="cnp"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-input
                                                :loading="!isCNPReady"
                                                :disabled="!isCNPReady"
                                                size="is-medium"
                                                class="is-fulllength"
                                                placeholder="CNP"
                                                v-model.trim="form.cnp"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                    <p class="has-text-info is-size-7" v-if="oneYearPeriod">
                                        Puteti redirectiona doar pentru anul 2025
                                    </p>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="email" name="email" v-slot="{ errors, valid, changed }">
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Email"
                                                type="email"
                                                v-model.trim="form.email"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider
                                        rules="required|phoneformat|phonedigits:10|phonevalability"
                                        name="telefon"
                                        vid="telefon"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-input
                                                :loading="!isTelefonReady"
                                                :disabled="!isTelefonReady"
                                                size="is-medium"
                                                placeholder="Telefon"
                                                v-model.trim="form.telefon"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div
                                class="subtitle has-text-weight-semibold is-size-4 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                            >
                                <div>
                                    <b-icon
                                        class="mr-3 has-text-grey-lighter"
                                        icon="map-marker-radius-outline"
                                        size="is-large"
                                    >
                                    </b-icon>
                                </div>
                                <div>Adresa</div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider
                                        vid="county"
                                        rules="required"
                                        name="judet"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-select
                                                :loading="isCountyLoading"
                                                @input="onCountySelect"
                                                size="is-medium"
                                                placeholder="Judet"
                                                v-model="form.judet"
                                                expanded
                                            >
                                                <option class="placeholder-option" value="" selected>
                                                    Alege judetul
                                                </option>
                                                <option v-for="judet in judete" :key="judet.id" :value="judet.name">
                                                    {{ judet.name }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider
                                        vid="city"
                                        rules="required"
                                        name="localitate"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-select
                                                :loading="isCityLoading"
                                                placeholder="Localitate"
                                                size="is-medium"
                                                v-model="form.localitate"
                                                :disabled="form.judet == null || form.judet === ''"
                                                expanded
                                            >
                                                <option class="placeholder-option" value="" selected>
                                                    Alege {{ form.judet === 'Bucuresti' ? 'sectorul' : 'localitatea' }}
                                                </option>
                                                <option
                                                    v-for="localitate in localitati"
                                                    :value="localitate.name"
                                                    :key="localitate.id"
                                                >
                                                    {{ localitate.name }}
                                                </option>
                                            </b-select>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider
                                        rules="required|max:45"
                                        name="strada"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Strada"
                                                v-model.trim="form.strada"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <ValidationProvider rules="max:10" name="numar" v-slot="{ errors, valid, changed }">
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Numar"
                                                v-model.trim="form.numar"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider rules="max:8" name="bloc" v-slot="{ errors, valid, changed }">
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Bloc"
                                                v-model.trim="form.bloc"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider rules="max:8" name="scara" v-slot="{ errors, valid, changed }">
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Scara"
                                                v-model.trim="form.scara"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider rules="max:5" name="etaj" v-slot="{ errors, valid, changed }">
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Etaj"
                                                v-model.trim="form.etaj"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                                <div class="column">
                                    <ValidationProvider
                                        rules="max:5"
                                        name="apartament"
                                        v-slot="{ errors, valid, changed }"
                                    >
                                        <b-field
                                            :type="{
                                                'is-danger': errors[0],
                                                'is-success': valid && changed,
                                            }"
                                            :message="errors"
                                        >
                                            <b-input
                                                size="is-medium"
                                                placeholder="Apartament"
                                                v-model.trim="form.apartament"
                                                minlength="1"
                                            ></b-input>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <hr />
                            <div class="columns is-desktop is-align-content-center is-align-items-center">
                                <div class="column">
                                    <div
                                        class="subtitle has-text-weight-semibold is-size-4 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                                    >
                                        <div>
                                            <b-icon
                                                class="mr-3 has-text-grey-lighter"
                                                icon="calendar-month-outline"
                                                size="is-large"
                                            >
                                            </b-icon>
                                        </div>
                                        <div>Perioada</div>
                                    </div>
                                </div>
                                <div class="column font-14">Alegeti perioada de distribuire a contributiei</div>
                                <div class="column">
                                    <ValidationProvider rules="required" name="localitate" v-slot="{ errors, valid }">
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-radio-button
                                                class="period-form"
                                                type="is-success"
                                                size="is-medium"
                                                v-model="form.perioada"
                                                name="perioada"
                                                native-value="1"
                                            >
                                                1 an
                                            </b-radio-button>
                                            <b-radio-button
                                                :disabled="oneYearPeriod"
                                                class="period-form"
                                                type="is-success"
                                                size="is-medium"
                                                v-model="form.perioada"
                                                name="perioada"
                                                native-value="2"
                                                checked
                                            >
                                                2 ani
                                            </b-radio-button>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <hr />

                            <div
                                class="mb-2 subtitle has-text-weight-semibold is-size-4 has-text-weight-bold is-flex is-align-content-center is-align-items-center"
                            >
                                <div>
                                    <b-icon
                                        class="mr-3 has-text-grey-lighter"
                                        icon="signature-freehand"
                                        size="is-large"
                                    >
                                    </b-icon>
                                </div>
                                <div>Semnatura</div>
                            </div>
                            <div class="columns mb-1 is-align-content-center is-align-items-center">
                                <div
                                    class="column is-two-thirds font-14"
                                    :class="{
                                        'is-one-thirds': screenWidth >= 1228,
                                        'is-three-fifths': screenWidth < 1228,
                                    }"
                                >
                                    Desenati in interiorul chenarului semnatura dumneavoastra
                                </div>
                                <div
                                    class="column"
                                    :class="{
                                        'has-text-right': screenWidth > 1228,
                                        'is-one-thirds': screenWidth >= 1228,
                                        'is-two-fifths': screenWidth < 1228,
                                    }"
                                >
                                    <b-button
                                        type="is-grey"
                                        class="reset-signature has-text-grey"
                                        outlined
                                        @click="clearSignature"
                                        >Reseteaza semnatura</b-button
                                    >
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <VueSignaturePad
                                        :class="{ invalid: isSignatureInvalid }"
                                        id="signature"
                                        width="100%"
                                        height="250px"
                                        ref="signaturePad"
                                    />
                                    <p class="mt-2 has-text-danger" v-if="isSignatureInvalid">
                                        Semnatura este obligatorie
                                    </p>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column agreement-checkbox">
                                    <ValidationProvider
                                        rules="optional|agreement"
                                        name="tos"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-checkbox type="is-success" v-model="form.consent">
                                                Sunt de acord ca datele de identificare (nume, prenume și cod numeric
                                                personal/număr de identificare fiscală), precum și suma direcționată să
                                                fie comunicate entității beneficiare.
                                            </b-checkbox>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column agreement-checkbox">
                                    <ValidationProvider
                                        rules="required|agreement"
                                        name="tos"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-checkbox type="is-success" v-model="checks.tos">
                                                Sunt de acord cu
                                                <span
                                                    class="tos has-text-success has-text-weight-semibold"
                                                    @click.prevent="openTOS"
                                                    >Termenii si conditiile de pe site.</span
                                                >
                                            </b-checkbox>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column agreement-checkbox">
                                    <ValidationProvider
                                        rules="required|agreement"
                                        name="gdpr"
                                        v-slot="{ errors, valid }"
                                    >
                                        <b-field
                                            :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                            :message="errors"
                                        >
                                            <b-checkbox type="is-success" v-model="checks.gdpr">
                                                Sunt de acord ca
                                                <span class="has-text-weight-semibold">Asociata Minti Creative</span> sa
                                                proceseze datele mele cu caracter personal pentru
                                                <span>depunerea formularului 230 la ANAF</span>.
                                            </b-checkbox>
                                        </b-field>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <b-button
                                size="is-large"
                                type="is-block  has-text-weight-bold is-success is-fullwidth"
                                @click="submit"
                                :loading="isSubmitPending"
                                :disabled="!isTelefonReady || !isCNPReady"
                                >DEPUNE FORMULARUL</b-button
                            >
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
        <b-modal
            full-screen
            v-model="isTosModalActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-modal
        >
            <template>
                <tos-modal @close="isTosModalActive = false"></tos-modal>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import kidsImage from '@/assets/kids.png';
import logo from '@/assets/logo_white.png';
import * as toast from '@/utils/toast';
import { mapState, mapGetters } from 'vuex';
const ToSModal = () => import('@/components/TosModal');
import { validateCNP } from '@/utils/functions';
const blankForm = {
    nume: '',
    initiala: '',
    prenume: '',
    strada: '',
    numar: '',
    bloc: '',
    scara: '',
    etaj: '',
    apartament: '',
    cnp: '',
    email: '',
    telefon: '',
    judet: '',
    localitate: '',
    perioada: '2',
    consent: true,
};

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        'tos-modal': ToSModal,
    },
    data: () => ({
        form: { ...blankForm },
        isSignatureInvalid: false,
        screenWidth: 1920,
        kidsImage,
        logo,
        isSubmitPending: false,
        invalidUID: false,
        checks: {
            tos: false,
            gdpr: false,
        },
        isTosModalActive: false,
        isCityLoading: false,
        isCountyLoading: false,
        CNPRegistrationMessage: '',
        cnpDebounce: null,
        registrationDisabled: false,
    }),
    methods: {
        async submit() {
            const observer = this.$refs.observer;
            const success = await observer.validate();
            if (!success) {
                for (const key of Object.keys(observer.fields).sort()) {
                    if (observer.fields[key].invalid) {
                        observer.refs[key].$el.scrollIntoView();
                        window.scrollBy(0, -200);
                        return;
                    }
                }
            }
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) {
                return (this.isSignatureInvalid = true);
            }
            const re = /^data:((?:\w+\/(?:(?!;).)+)?)((?:;[\w\W]*?[^;])*),(.+)$/;
            if (!re.test(String(data).toLowerCase())) {
                return (this.isSignatureInvalid = true);
            }
            if (this.currentId == null || this.currentId === '' || this.currentId == 0) {
                return toast.error('ID-ul beneficiarului este invalid', 6000, 'is-top');
            }
            this.isSignatureInvalid = false;
            const params = Object.assign({}, this.form);
            params.signature = data;
            params.uid = this.currentId;
            this.isSubmitPending = true;
            try {
                const result = await this.$store.dispatch('formular/SendFormular', params);
                const fullSuccess =
                    'Formularul a fost inregistrat! <br> O copie a fost trimisa pe email daca ati introdus adresa in formular';
                const noEmail =
                    'Formularul a fost inregistrat! <br> Nu am putut trimite email cu copia pe adresa furnizata';
                const noDownload =
                    'Formularul a fost inregistrat! <br> Nu am putut genera fisierul pentru descarcare. <br> Va rugam sa contactati asociata pentru o copie a forumularului';

                let finalMessage;

                switch (true) {
                    case result.emailStatus == 0 && result.pdfStatus == 0:
                    case result.pdfStatus == 0:
                        finalMessage = noDownload;
                        break;

                    case result.emailStatus == 0:
                        finalMessage = noEmail;
                        break;

                    default:
                        finalMessage = fullSuccess;
                }

                // this.$buefy.snackbar.open({
                //     duration: 3000,
                //     message: finalMessage,
                //     type: 'is-success',
                //     position: 'is-top',
                //     actionText: 'Inchide',
                //     queue: false,
                // });

                this.form = { ...blankForm };
                this.checks = {
                    tos: false,
                    gdpr: false,
                };
                this.clearSignature();
                this.$store.commit('formular/SET_FORMULAR_ONE_YEAR_STATUS', false);

                // if (result.pdfStatus == 1 && result.data != null) {
                //     // window.open(createBlob('application/pdf', result.data), '_blank');
                //     // const tab = window.open();
                //     // const blobUrl = createBlob('application/pdf', result.data);
                //     // tab.location.href = blobUrl;
                // }
                this.$router.push({
                    name: 'RegistrationSuccess',
                    params: { pdfData: result.pdfStatus == 1 && result.data != null ? result.data : null },
                });
            } catch (err) {
                toast.error(`Eroare la salvarea formularului ${err.message}`);
                this.$reportToSentry(err, {
                    extra: {
                        fn: 'submit',
                        params: {
                            event: 'submit',
                            err,
                        },
                    },
                });
            } finally {
                setTimeout(() => {
                    this.isSubmitPending = false;
                }, 1500);
            }

            return true;
        },
        clearSignature() {
            return this.$refs.signaturePad.clearSignature();
        },
        windowSizeChanged(e) {
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        },
        openTOS() {
            this.isTosModalActive = true;
        },
        async onCountySelect(countyName) {
            const countyObj = this.judete.find((judet) => judet.name === countyName);
            if (countyObj == null) {
                return toast.error('Judet invalid');
            }
            this.isCityLoading = true;
            try {
                await this.$store.dispatch('app/GetCitiesByCountyId', countyObj.id);
                this.$refs.observer.refs.localitate.setFlags({ changed: true, touched: true, untouched: false });
            } catch (err) {
                console.log(err);
                toast.error('Eroare la preluarea localitatilor');
                this.$reportToSentry(err, {
                    extra: {
                        fn: 'onCountySelect',
                        params: {
                            event: 'onCountySelect',
                            countyName,
                        },
                    },
                });
            } finally {
                this.isCityLoading = false;
            }
        },
    },
    computed: {
        ...mapState({
            beneficiar: (state) => state.formular.account.name,
            ibanBeneficiar: (state) => state.formular.account.iban,
        }),
        ...mapGetters({
            currentId: 'formular/currentId',
            isCNPReady: 'formular/isCNPReady',
            isTelefonReady: 'formular/isTelefonReady',
            judete: 'app/counties',
            localitati: 'app/cities',
            oneYearPeriod: 'formular/oneYearPeriod',
        }),
    },
    async created() {
        this.isSubmitPending = true;
        window.addEventListener('resize', this.windowSizeChanged);
        this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        const id = this.$route.params?.uid;
        if (id == null || id === '') {
            this.invalidUID = true;
            this.isSubmitPending = false;
            return false;
        }

        this.isCountyLoading = true;
        try {
            await this.$store.dispatch('app/GetCounties');
        } catch (err) {
            toast.error('Eroare la preluarea judetelor', 6000, 'is-top');
            this.$reportToSentry(err, {
                extra: {
                    fn: 'GetCounties',
                    params: {
                        event: 'GetCounties',
                    },
                },
            });
        } finally {
            this.isCountyLoading = false;
        }

        try {
            await this.$store.dispatch('formular/GetAccount', id);
            this.$store.commit('formular/SET_CURRENT_ID', id);
        } catch (err) {
            this.invalidUID = true;
            this.$reportToSentry(err, {
                extra: {
                    fn: 'GetAccount',
                    params: {
                        event: 'GetCounties',
                        id,
                    },
                },
            });
        } finally {
            this.isSubmitPending = false;
        }
    },
    watch: {
        oneYearPeriod(value, oldValue) {
            if (value == true && +this.form.perioada == 2) {
                this.form.perioada = '1';
            } else this.form.perioada = '2';
        },
        'form.judet'(val, oldVal) {
            if (oldVal !== '') {
                this.form.localitate = '';
            }
        },
    },
    async mounted() {
        // setTimeout(() => {
        //     this.form = {
        //         nume: 'Tanase',
        //         initiala: '',
        //         prenume: 'Alin',
        //         strada: 'sesase',
        //         numar: '',
        //         bloc: '',
        //         scara: '',
        //         etaj: '',
        //         apartament: '',
        //         cnp: '6200708047611',
        //         email: 'alintanase92@gmail.com',
        //         telefon: '0762985485',
        //         judet: 'Bucuresti',
        //         // localitate: 'Sector 3',
        //         perioada: '2',
        //     };
        // }, 1000);
    },
    beforeDestroy() {
        document.documentElement.className = '';
        window.removeEventListener('resize', this.windowSizeChanged);
    },
};
</script>

<style lang="scss" scoped>
.top-text {
    margin-bottom: 1rem;

    .title {
        margin-bottom: 0;
    }

    .formular-title-text {
        border-right: 2px solid #4d6e85;
        margin-right: 15px;
        padding-right: 15px;

        &.on-mobile {
            border: 0;
            font-size: 1.9rem;
        }
    }

    .sub-text {
        font-size: 13px;
        font-weight: 600;
        color: hsl(0deg 0% 100% / 79%);
    }
}

.column-right {
    box-shadow: 0 0 white, 0 0 #3e3e3e00, 0 0 0 0 #00000000, -7px 0 10px -1px rgb(0 0 0 / 0.22);
    position: relative;
    .box {
        border-radius: 0px 6px 6px 0px;
    }
}

.column-left {
    background-color: #296c9e;
    border-radius: 6px 0px 0px 0px;
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: contain;
    color: #fff !important;

    .subtitle {
        color: #fff !important;
    }
}

.column-left,
.column-right {
    padding: 0;
}

#signature {
    border: 1px solid #296b9eb0;
    border-radius: 5px;
    box-shadow: 0em 0em 0.5em 0.1em #2a6e9e9e, 0 0px 0px #b5b5b500;

    &.invalid {
        border: 1px solid #f14668;
        box-shadow: 0em 0em 0.5em 0.1em #f14668, 0 0px 0px #f14668;
        // background-image: linear-gradient(white, white), radial-gradient(circle at top left, #f14668, #f14668);
    }
}

.reset-signature {
    margin-bottom: 5px;
}

// ::v-deep .placeholder-color select {
//     color: hsl(0, 0%, 86%) !important;
// }

.font-14 {
    font-size: 0.9rem;
    font-weight: 500;
}

.period-form {
    &:not(:last-child) {
        margin-right: 20px !important;
    }

    .radio {
        border-radius: 10px !important;
    }
}

.is-size-4 {
    font-size: 1.5rem !important;
}

hr {
    background-color: #dbdbdb;
}

.info {
    display: table;
    margin: 0 auto;
    margin-top: 25px;
    padding: 40px;
    padding-top: 0;
    opacity: 0.9;

    .info-text {
        font-size: 0.9rem;
        padding-top: 5px;
    }
}

.on-mobile-left {
    border-radius: 6px 6px 0px 0px;
}
.on-mobile-right .box {
    border-radius: 0px 0px 6px 6px;
}

.form-title {
    font-size: 1.8rem;
}

.text-with-border {
    border: 1px solid;
    background-color: white;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    height: 3.5em;
    font-size: 0.9rem;
    line-height: 1.5;
    padding-bottom: calc(0.5em - 1px);
    padding-left: calc(0.75em - 1px);
    padding-right: calc(0.75em - 1px);
    padding-top: calc(0.5em - 1px);
}

::v-deep .on-mobile input:disabled {
    -webkit-appearance: none;
    color: #7a7a7a !important;
    background-color: #f5f5f5bf;
    -webkit-text-fill-color: #7a7a7a !important;
    -webkit-opacity: 1 !important;
    opacity: 1 !important;
}

.overlay-invalid {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    overflow: hidden;
    z-index: 999;

    .ov-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        background: #7f7f7f;
        background: rgb(255 255 255 / 78%);
    }

    .ov-text {
        padding: 50px;
        background-color: #296c9e;
        z-index: 120;
        color: #fff;
        border-radius: 6px;
        position: fixed;
        top: 20em;
        box-shadow: 6px 6px 5px rgb(0 0 0 / 33%);
        max-width: 40em;
    }
}

::v-deep .snackbar em {
    font-size: 0.95rem;
}

.agreement-checkbox {
    font-size: 0.9rem;
}

.tos {
    text-decoration: underline;
}

.logo {
    margin-bottom: 25px;
}
</style>
